import { memo } from 'react'

import { LineTileShape, LineTileSize } from '@/constants/common'
import { TileProps } from '@/types/componentsPropsTypes'
import { tileTypes } from '@/types/servicesTypes/configTypes'
import { SlideDataType } from '@/types/sliderTypes'

import { HtmlWidgetTile } from './HtmlWidgetTile'
import { Tile } from './Tile'
import { ViewMoreTile } from './ViewMoreTile'

type Props = {
  index: number
  sliderId: string
  categoryId?: string
  slide: SlideDataType
  tileShape?: LineTileShape
  tileSize?: LineTileSize
  broadcastId: string
  onMouseOverTile?: (data: SlideDataType, focusId: string) => void
  isActive?: boolean
}

const LineTileRaw = ({
  slide,
  sliderId,
  categoryId,
  tileShape,
  tileSize,
  index,
  broadcastId,
  onMouseOverTile,
  isActive,
}: Props) => {
  const slideType = slide.type

  const props = {
    focusId: `${sliderId}_${slide.id}_${index}`,
    tileShape,
    tileSize,
    categoryId,
    onMouseOverTile,
    isLineTile: true,
    isActive,
  }

  const tileProps: TileProps = {
    ...props,
    data: slide as SlideDataType,
    broadcastId,
  }

  switch (slideType) {
    case tileTypes.HTML_WIDGET: {
      const htmlWidget = slide.data?.htmlWidget
      return (
        <HtmlWidgetTile
          {...tileProps}
          url={htmlWidget?.url}
          renderInTile={htmlWidget?.renderInTile}
        />
      )
    }

    case tileTypes.SHOW_MORE: {
      return <ViewMoreTile {...tileProps} />
    }
  }

  return (
    <Tile {...tileProps} isChannelSlider={sliderId.includes('ChannelSlider')} />
  )
}

export const LineTile = memo(LineTileRaw)
